// client/src/components/Header.js

import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import logo from '../assets/appicon.png'

function Header() {
    
    const [isSticky, setIsSticky] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) { // Adjust the scroll threshold as needed
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const [isMenuVisible, setMenuVisible] = useState(false);
    const toggleMenu = () => {
        setMenuVisible(!isMenuVisible);
      };
    
    return (
        <header>        
            <div id="sticky-header" className={`menu-area transparent-header ${isSticky ? 'sticky-menu' : ''}`}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>

                            <div className="mobile-nav-toggler" onClick={toggleMenu}><i className="fs-1 bi bi-list"/></div>

                            <div className={`menu-wrap ${isMenuVisible ? 'mobile-menu-visible' : ''}`}>
                                <nav className="menu-nav">
                                    <div className='logo'>
                                        <a href="https://bauphysik-tool.de" style={{cursor: 'none' }}><img src={logo} alt="BauphysikTool" style={{ width: '80px', height: 'auto', maxWidth: '100%' }}/></a>
                                    </div>
                                    <div className='navbar-wrap main-menu d-none d-lg-flex'>
                                        <ul className='navigation'>
                                            <li className="active">
                                                <Link to="https://bauphysik-tool.de" title="Startseite" style={{cursor: 'none'}}>Home</Link>
                                            </li>
                                            <li className="">
                                                <Link to="https://bauphysik-tool.de/downloads" title="Downloads" style={{cursor: 'none'}}>Downloads</Link> 
                                            </li>
                                            <li className="">
                                                <Link to="https://bauphysik-tool.de/blog" title="Blog" style={{cursor: 'none'}}>News</Link> 
                                            </li>
                                        </ul>
                                    </div> 
                                </nav>

                                <div className="mobile-menu">
                                    <div className='menu-box'>
                                        <div className="close-btn" onClick={toggleMenu}><i className="bi bi-x-lg"/></div>
                                        <div className="nav-logo"><a href="/" style={{cursor: 'none'}}><img src={logo} alt="BauphysikTool"/></a></div>
                                        <div className='menu-outer'>
                                            <ul className="navigation">
                                                <li className="active"><Link to="/" title="Startseite" style={{cursor: 'none'}}>Home</Link></li>
                                                <li className=""><Link to="/downloads" title="Downloads" style={{cursor: 'none'}}>Downloads</Link> </li>
                                                <li className=""><Link to="/blog" title="Blog" style={{cursor: 'none'}}>News</Link></li>
                                            </ul>
                                        </div>
                                        <div className="social-links">
                                            <ul className="clearfix list-wrap">
                                                <li><a href="https://www.linkedin.com/in/arne-schunter" style={{cursor: 'none'}}><i className="bi bi-linkedin"/></a></li>
                                                <li><a href="https://github.com/nbungu" style={{cursor: 'none'}}><i className="bi bi-github"/></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className='menu-backdrop'></div>

                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </header>
)}

export default Header